<div class="store-faq" *ngIf="pageContent$ | async as pageContent">
    <div class="section" *ngFor="let section of pageContent">
        <h2 class="title">{{section.title}}</h2>
        <p *ngIf="section.description">{{section.description}}</p>
        <ul *ngIf="section.bulletPoints?.length">
            <li *ngFor="let bullet of section.bulletPoints">
                <h3>
                    <span>
                        <a class="highlight" *ngIf="bullet.link; else noLink" [href]="bullet.link" target="_blank">{{ bullet.title }}</a>
                        <ng-template #noLink>{{ bullet.title }}</ng-template>
                    </span>
                    <span *ngIf="bullet.description">: {{ bullet.description }}</span>
                </h3>
                <!-- <h3 class="highlight" [href]="bullet.link" target="_blank">{{bullet.title}}</h3>
                <h3 *ngIf="bullet.description">{{bullet.description}}</h3> -->
            </li>
        </ul>
        <div class="learn-more" *ngIf="section.learnMore?.length">
            <h3 class="highlight">
            <a>👉 Read more: </a>
            <span *ngFor="let item of section.learnMore; let last = last">
                <a class="highlight" [href]="item.link" target="_blank">{{item.title || 'Learn more >'}}</a><span *ngIf="!last">, </span>
            </span>
            </h3>
        </div>
    </div>
</div>
